import ContentHeader from 'component/utils/ContentHeader'
import React, {useEffect, useState } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import Col from 'component/utils/Col'
import Grid from 'component/utils/Grid'
import Button from 'component/Button/index'
import filterIcon from 'images/filter-icon.svg'
import FilterIconSVG from 'component/svgComponents/filter'
import PropTypes from 'prop-types'
import SideFilterForm from 'component/analyticsNew/SideFilter'
import MostAccessedTable from '../../components/analyticsNew/mostAccessedTable'
import updateData from 'images/update-data.svg'
import * as analyticsActions from 'action/analyticsNew'
import { bindActionCreators } from 'redux'
import Row from 'component/utils/Row'
import { isEmpty } from '../../utils/validations'
import moment from 'moment'
import * as spinnerActions from 'action/spinner'
import MyResponsivePie from 'component/pieBar'
import Arrow from '../../components/utils/Arrow'
import './styles.css'
import EyeIconSvg from 'component/analyticsNew/EyeIcon.js'
import { browserHistory } from 'react-router'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import _ from 'lodash'


let devicesUpdateAbortController
let activeInActiveAbortController
let mostAccessedMobileAbortController
let mostAccessedWebAbortController
const DEFAULT_FILTER_INITIAL_VALUES = {
  branchs: [],
  period: null
}

const AnalyticsContainer = ({ translate, auth, menusMobile = [], menusWeb = [],  reloadData,  listDevicesUpdate = [], listUsersAccess = [], listFiltersGlobal}) => {

  const [filters,setFilters] = useState(DEFAULT_FILTER_INITIAL_VALUES)

  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [oneRegion, setOneRegion] = useState([])
  const [dataPie,setDataPie] = useState([])
  const [optionsBranchs, setOptionsBranchs] = useState([])
  const [missionsSelectBranchs, setMissionsSelectBranchs] = useState([])
  const [oneStore, setOneStore] = useState('')

  const [isCanceled, setIsCanceled] = useState(false);

  const hasCancelled = (data) => isCanceled && isEmpty(data)

  useEffect(() => {
      if(_.isEqual(DEFAULT_FILTER_INITIAL_VALUES,filters) && !_.isEmpty(listFiltersGlobal))
      
      {
      let branchs = []

      const newValues = {...listFiltersGlobal}

      for (const b of newValues.branchs || []) {
        if (b.idBranches) {
          branchs.push(...b.idBranches)
          branchs.push(b.value)
          if(b.length === 1) onStore(b.value)
        } else {
          branchs.push(b.value)
          branchs.push(b.idRegion)
          onStore(b.label)
        }
      }
      onRegion(newValues.branchs)
      branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)

      newValues.branchs = branchs
      setFilters(newValues)
      }
  }, [])

  useEffect(() => {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }

    getParameter(params).then(resp => {
      const missions = resp.data.split(",")
      setMissionsSelectBranchs(missions)
    })
    
  },[])

  const getParameter = (values) => new Api(auth.user.dsToken)
    .get(API_URL.PARAMETER_GET, values)

  useEffect(() => {

    const newDataPie = [{
      "id": "updated",
      "label": "",
      "value": listDevicesUpdate.percentUpdated,
      "color": "#41a017",
    }, {
      "id": "notUpdated",
      "label": "",
      "value": listDevicesUpdate.percentNotUpdated,
      "color": "#eeeef0",
    }]
    setDataPie(newDataPie)

  }, [listDevicesUpdate])

  const onStore = (values) => {
    setOneStore(values)
  }

  const onRegion = (value) => setOneRegion(value)

  const updatingData = () => {
    const dtStart = moment(filters.dtBegin).format("DD/MM/YYYY")
    const dtEnd = moment(filters.dtEnd).format("DD/MM/YYYY")
    const params = { branchs: filters.branchs, dtInicio: dtStart, dtFim: dtEnd }
    
    setIsCanceled(false)

    const onCancelCallback = () => {
      setIsCanceled(true);
    };

    devicesUpdateAbortController = new AbortController()
    activeInActiveAbortController = new AbortController()
    mostAccessedMobileAbortController = new AbortController()
    mostAccessedWebAbortController = new AbortController()
    reloadData(
      auth, 
      params, 
      devicesUpdateAbortController, 
      activeInActiveAbortController, 
      mostAccessedMobileAbortController, 
      mostAccessedWebAbortController,
      onCancelCallback
    )
  }

  const renderOptions = () => <div className='float-right margin-top flex flex-row'>
    <Button
      className= {`btn btn-primary margin-right new-analytics-button-update ${isEmpty(filters.dtBegin) ? 'disabled' : ''} `}
      text={translate('configurationFragment.updateRecords')}
      icon={updateData}
      onClick={updatingData}

    />
    <Button
      className='btn btn-secondary new-analytics-button-filter'
      icon={filterIcon}
      svgIcon
      svgComponent={<FilterIconSVG className="margin-default-svg" newDesign={false} />}
      onClick={() => setSideFilterVisible(true)}
      text={translate('linear.conference.justification.filter.button')}
    />
  </div>


  const regionStores = [1,2,3,4,7]

  const daysText = {
    0: 'analytics.today',
    7: "7",
    15: "15",
    28: "30",
    29: "30",
    30: "30",
    31: "30"

  }

  const toggleSideFilter = () => {
    setSideFilterVisible(false)
  }

  const renderWebAccess = () => {

    const webAccess = menusWeb.map(menu => ({funcionality: translate(menu.dsChaveMenu), access:  menu.count, tendency: menu.tendency.toString()})).sort((a,b) => a.access < b.access)

    return <MostAccessedTable text={"mobile.reports"} translate={translate} data={webAccess} />
  }

  const renderMobileAccess = () => {
    const mobileAccess = menusMobile.map(menu => ({funcionality: translate(menu.dsChaveMenu), access: menu.count, tendency: menu.tendency.toString()})).sort((a,b) => a.access < b.access)

    return <MostAccessedTable text={"analytics.funcionalities"} translate={translate} data={mobileAccess} />
  }

  const renderSideFilter = () => {

    const onFilter = (values) => {

      setSideFilterVisible(false)
      setFilters(values)

      values.branchs = values.branchs.filter(branch => branch !== undefined)
      // all branchs = idBranches: [] in backend controller params
      if(values.branchs.length === optionsBranchs.length) values.branchs = []

      const dtStart = moment(values.dtBegin).format("DD/MM/YYYY")
      const dtEnd = moment(values.dtEnd).format("DD/MM/YYYY")

      values.dtInicio = dtStart
      values.dtFim = dtEnd

      setIsCanceled(false)

      const onCancelCallback = () => {
        setIsCanceled(true);
      };
  
      devicesUpdateAbortController = new AbortController()
      activeInActiveAbortController = new AbortController()
      mostAccessedMobileAbortController = new AbortController()
      mostAccessedWebAbortController = new AbortController()

      reloadData(auth, 
        values, 
        devicesUpdateAbortController, 
        activeInActiveAbortController,  
        mostAccessedMobileAbortController, 
        mostAccessedWebAbortController,
        onCancelCallback
      )

    }

  return (
    <SideFilterForm
      show={sideFilterVisible}
      closeFilter={toggleSideFilter}
      onSubmit={onFilter}
      translate={translate}
      auth={auth}
      optionsBranchs={(options) => setOptionsBranchs(options)}
      sendStore={onStore}
      sendRegion={onRegion}
      missionsSelectBranchs={missionsSelectBranchs}
      />
  )
}

 const renderSeeMoreDetails = (typeLink) => (
    <Button
        onClick={() => browserHistory.push(`analytics-new/${typeLink}`)}
        className='btn new-analytics-details'
        svgIcon
        svgComponent={<EyeIconSvg class="eye-svg" />}
        text={translate('see.more.details')} />
  )

  const renderVersionText = (text='') => {
    text+= `${translate('analytics.new.lastVersion')}: ${listDevicesUpdate.versionCode || '58.1.2'} - `;
    return renderStoreText(text)
  }

  const capitalizeFirstLetter = (string)  => string.charAt(0).toUpperCase() + string.slice(1)

  const renderStoreText = (text='') => {

    const allStores = filters.branchs.length === 0 || filters.branchs.length === optionsBranchs.length + 1
    const someStores = filters.branchs.length > 2 && filters.branchs.length < optionsBranchs.length && oneRegion.length > 1
    const regionStore = filters.branchs.length < optionsBranchs.length && filters.branchs.length >= 8 && regionStores.includes(oneRegion[0].value) && oneRegion.length === 1


    switch(true) {
      case allStores:
        text+= translate('analytics.all-stores')
        break;
      case regionStore:
        text+= oneRegion[0].label
        break;
      case someStores:
        text+= translate('analytics.select-stores')
        break;
      default:
        const storeFormated = oneStore.substring(8  - onStore.length).toLowerCase()
        const arrayStoreText = storeFormated.split(/[. ]+/)
        const capitalizedText = arrayStoreText.map( a => capitalizeFirstLetter(a))
        const storeFormatedCamel = capitalizedText.join(" ")
        text+= ` ${storeFormatedCamel}`
    }
     return <p className='new-analytics-store-period'> {text} </p>

}

 const renderDaysStoreText = () => {

      let text = ''
      if(!isEmpty(filters) ) {
        const dtBegin = moment(filters.dtBegin)
        const dtEnd = moment(filters.dtEnd)
        const diffDays = dtEnd.diff(dtBegin, 'day')
        const dtBeginFormated = dtBegin.format('L')
        const dtEndFormated = dtEnd.format('L')
        const currentDate = moment().format('L')
        const isLastSevenDays = diffDays === 7 && dtEndFormated === currentDate
        const isLastFifteenDays = diffDays === 15 && dtEndFormated === currentDate
        const isLastMonthDays = [28,29,30,31].includes(diffDays) && dtEndFormated === currentDate
        const isYesterday = dtBeginFormated === dtEndFormated && moment().endOf('day').diff(dtEnd, 'day') === 1
        const isToday = dtBeginFormated === dtEndFormated && dtBegin.startOf('day').isSame(moment().startOf('day'))

        switch(true) {
            case isToday:
              text+= `${translate('analytics.today')} - `
              break;

            case isYesterday:
              text+= `${translate('analytics.yesterday')} - `
              break;

            case isLastSevenDays || isLastFifteenDays || isLastMonthDays:
              text+= `${translate('analytics.lasts')} ${daysText[diffDays]} ${translate("analytics.days")} - `
              break;

            default:
                text+= `${dtBeginFormated} - ${dtEndFormated} - `
          }

          return renderStoreText(text)

      }
 }

  return (
    <div style={{paddingBottom: '25px'}} className='new-analytics-wrap'>

    <ContentHeader className="new-analytics-content-header">{translate('analytics.overview')}</ContentHeader>
    <div className='container-new-analytics'>

      <section className='new-style'>

        <Grid fluid className='new-upper-container'>
          <Col xs={12} md={6} className='float-right'>
            {renderOptions()}
          </Col>
        </Grid>

        {renderSideFilter()}
      </section>

      <section style={{marginRight: '10px'}} className='margin-top'>
        <Row>
          <Col className="col-new-analytics" xs={6}>
            <div className='card-box card-new-analytics'>
              <div className='card-new-analytics-header'>
                <span className='new-analytics-title'>{translate('analytics.mostAccessedMobile')}</span>

                {isEmpty(filters.dtBegin) ? null : 
                hasCancelled(menusMobile) ? null : 
                (
                    <>
                      {renderSeeMoreDetails('funcionalities')}
                      {renderDaysStoreText()}
                    </>
                  )
                }

              </div>

              { isEmpty(filters.dtBegin) ? (
                <div className='new-analytics-no-data'>
                <span>Sem filtro selecionado</span>
                </div>
              ) : hasCancelled(menusMobile) ? 
              (
                <div className='new-analytics-no-data'>
                  <span>Carregamento cancelado</span>
                </div>
              ) : renderMobileAccess()

              }

            </div >
          </Col>  

          <Col className="col-new-analytics" xs={6}>
            <div className='card-box card-new-analytics'>
              <div className='card-new-analytics-header'>
                <span className='new-analytics-title'>{translate('analytics.new.mostAccessedWeb')}</span>

                {isEmpty(filters.dtBegin) ? null : 
                hasCancelled(menusWeb) ? null : 
                (
                    <>
                      {renderSeeMoreDetails('relatories')}
                      {renderDaysStoreText()}
                    </>
                  )
                }

              </div>

              { isEmpty(filters.dtBegin) ? (
                <div className='new-analytics-no-data'>
                <span>Sem filtro selecionado</span>
                </div>
              ) : hasCancelled(menusWeb) ? (
                <div className='new-analytics-no-data'>
                  <span>Carregamento cancelado</span>
                </div>
              ) : renderWebAccess()
              }

            </div>
          </Col>
        </Row>
        
        <Row>
          <Col className="col-new-analytics" xs={6} >
            <div className='card-box card-new-analytics-2'>
              <div className='card-new-analytics-header'>
                <span className='new-analytics-title'>{translate('analytics.updateVersionApp')}</span>
              </div>

              { isEmpty(filters.dtBegin) ? (
                <div className='new-analytics-no-data'>
                <span>Sem filtro selecionado</span>
                </div>
                ) : hasCancelled(listDevicesUpdate) ? (
                  <div className='new-analytics-no-data'>
                    <span>Carregamento cancelado</span>
                  </div>
                ): isEmpty(listDevicesUpdate) ? (
                  <div className='new-analytics-no-data'>
                    <span>Sem dados</span>
                  </div>
                ): (
                  <>
                    <div>
                      {renderVersionText()}
                    </div>

                    <div className='new-analytics-version'>
                      <div >
                        <p>{translate('analytics.updated')}</p>
                        <span className='new-analytics-update-label'>{listDevicesUpdate.devicesUpdated}</span>
                      </div>

                      <div >
                      <p>{translate('analytics.notUpdated')}</p>
                      <span className='new-analytics-update-label'>{listDevicesUpdate.devicesNotUpdated}</span>
                      </div>
        
                      <div className='new-analytics-pie'>
                      <MyResponsivePie data={dataPie} height={180} width={200} />
                      </div>
                    </div>
                  </>
                )
              }

            </div>
          </Col>

          <Col className="col-new-analytics" xs={6}>
            <div className='card-box card-new-analytics-2'>
              <div className='card-new-analytics-header'>
                <span className='new-analytics-title'>{translate('analytics.accessQty')}</span>
              </div>

              { isEmpty(filters.dtBegin) ? (
                <div className='new-analytics-no-data'>
                <span>Sem filtro selecionado</span>
                </div>
              ) : hasCancelled(listUsersAccess) ? (
                <div className='new-analytics-no-data'>
                  <span>Carregamento cancelado</span>
                </div>
              ): isEmpty(listUsersAccess) ? (
                <div className='new-analytics-no-data'>
                    <span>Sem dados</span>
                  </div>
              ) : (
                <>
                  {renderStoreText()}
                  <div  className='new-analytics-version-2'>
                    <div className='new-analytics-last-30'>
                      <p>{translate('analytics.last30days')}</p>
                      <div className='new-analytics-last'> <span  >{listUsersAccess.activeLastMonth || '0'}</span> </div>
                      <Arrow fontSize={18} lineHeight={21.6} value={(listUsersAccess.tendencyLastMonth  || 0).toString()} />
                    </div>

                    <div className='new-analytics-last-day'>
                      <p>{translate('analytics.last24hours')}</p>
                      <div className='new-analytics-last'> <span>{listUsersAccess.activeLastDay || '0'}</span> </div>
                      <Arrow fontSize={18} lineHeight={21.6} value={(listUsersAccess.tendencyLastDay || 0).toString()} />
                    </div>
                  </div>
                 </>
              )}

            </div>
          </Col>
        </Row>
      </section>
    </div>
    </div>
    )

}

AnalyticsContainer.propTypes = {
  translate: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  reloadData: PropTypes.func.isRequired,
  cleanData: PropTypes.func.isRequired,
  listMostAccess: PropTypes.array,
  menusWeb: PropTypes.array,
  menusMobile: PropTypes.array,
  listDevicesUpdate: PropTypes.array,
  listUsersAccess: PropTypes.array,
  listFiltersGlobal: PropTypes.object
}
 
const AnalyticsContainerTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(AnalyticsContainer)

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...analyticsActions, ...spinnerActions }, dispatch)

  const mapStateToProps = ({ analyticsReducer }) => ({
    analyticsNew: analyticsReducer,
    listMostAccess: analyticsReducer.listMostAccess.record,
    listDevicesUpdate: analyticsReducer.devices.record,
    menusWeb: analyticsReducer.menusWeb.record,
    menusMobile: analyticsReducer.menusMobile.record,
    listUsersAccess: analyticsReducer.users.record,
    listFiltersGlobal: analyticsReducer.listFiltersGlobal.record,
  })

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticsContainerTranslated)
